var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "faq-article-content-wrapper" },
    [
      _vm.articleHeader
        ? _c("div", [
            _c("div", [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.articleHeader) } })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "faq-divider" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.faqsData, function(faq, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "px-0",
            class: _vm.showDivider(_vm.faqsData, i) ? "faq-divider" : ""
          },
          [
            _c(
              "div",
              { staticClass: "faq-wrapper py-4 pr-4" },
              [_c("knowledge-faq-collapsible", { attrs: { faq: faq } })],
              1
            )
          ]
        )
      }),
      _vm._v(" "),
      _vm.articleFooter
        ? _c("div", [
            _c("div", { staticClass: "faq-divider" }),
            _vm._v(" "),
            _c("div", { staticClass: "pt-3" }, [
              _c("p", { domProps: { innerHTML: _vm._s(_vm.articleFooter) } })
            ])
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13f094da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f094da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/knowledge-article/KnowledgeFaqArticleContent.vue
// module id = null
// module chunks = 